export const Dictionary = {
  CANCEL: 'Cancel',
  VALIDATE: 'Validate',
  LINK_ACCOUNT: 'Link Account',
  SUBMIT: 'Submit',
  TO: 'To',
  FROM: 'From',
  DOWNLOAD: 'Download',
  RECEIVED: 'Received',
  NOTIFICATIONS: 'Notifications',
  DATE: 'Date',
  DOWNLOAD_FILE: 'Download File',
  DOWNLOAD_FILES: 'Download {0} Files',
  CONTINUE: 'Continue',
  CLOSE: 'Close',
  OK: 'Ok',
  CONTACT_US: 'Contact Us',
  MESSAGE: 'Message',
  INFORMATION: 'Information',
  FINISH: 'Finish',
  STEP: 'Step',
  FORM: 'Form',
  DEFAULT_ERROR: 'Data loading failed',
  NEED_HELP: 'Need Help?',
  LOG_OUT: 'Log Out',
  SAVE: 'Save',
  PROFILE: 'Profile',
  MY: 'My',
  UNREAD: 'Unread',
  ALL: 'All',
  TYPE: 'Type',
  REQUEST_FAILED: 'Request failed.',
  REQUEST_SENT: 'Request Sent!',
  NAME: 'Name',
  WELCOME: 'Welcome',
  DELETE: 'Delete',
  ENTER_PASSWORD: 'Please Enter Password',
  ENTER_USERNAME: 'Please Enter Username',
  WELCOME_TO_SYSTEM: 'Welcome to the {0} Web Portal. To register your account, please complete the information below.',
  REGISTRATION_COMPLETE: 'Registration Complete!',
  FORGOT_USERNAME: 'Forgot Username?',
  ENTER_PIN: 'Please Enter PIN',
  LOOKING_FOR_HELP: 'Looking for help?',
  INVALID_EMAIL_ADDRESS: 'Invalid email address entered',
  WE_ARE_HERE_TO_HELP: 'We’re here to help any time',
  CLICK_FOR_HELP: 'click here for help',
  ENTER_ACCOUNT_NUM: 'Please Enter Account#',
  ENTER_EMAIL: 'Please Enter Email',
  PASSWORD_RESET: 'Password Reset',
  USERNAME: 'Username',
  REGISTER_NEW_ACCOUNT: 'Register New Account',
  ACCOUNT_VERIFICATION: 'Account Verification',
  CHALLENGE_QUESTIONS: 'Security Questions',
  USER_PROFILE: 'User Profile',
  PASSWORD: 'Password',
  HIDE_PASSWORD: 'Hide password',
  USERID_DOESNT_EXIST: 'The UserID doesn\'t exist',
  SELECT_CAPTCHA: 'Please select captcha',
  SHOW_PASSWORD: 'Show password',
  FORGOT_PASSWORD: 'Forgot Password?',
  SIGN_IN: 'Sign In',
  REGISTER: 'Register',
  NOT_YET_REGISTERED: 'Not Yet Registered? Click Here to',
  SPECIAL_INSTRUCTIONS: 'Special Instructions',
  PHONE: 'Phone',
  ZIP: 'Zip',
  EMAIL: 'Email',
  ZIP_CODE: 'Zip Code',
  TAX_ID_SOC_SEC: 'Tax ID/Soc Sec.#',
  SHOW_TAX_ID_SOC_SEC: 'Show Tax ID/Soc Sec.#',
  HIDE_TAX_ID_SOC_SEC: 'Hide Tax ID/Soc Sec.#',
  TAX_ID: 'Tax ID',
  IF_YOU_ADVISOR: 'If You Are A New Advisor, Click Here to',
  IF_YOU_DO_NOT_HAVE_YOUR_PIN: 'If you do not have your PIN, please continue for further verification.',
  IF_YOU_DO_NOT__HAVE_YOUR_PIN_REP: 'If you do not have your PIN, please call us at {0}',
  ENTER_THE_PIN_THAT_WAS_PROVIDED: 'Enter the PIN that was provided to you by email or mail',
  PIN: 'PIN',
  FAX: 'Fax',
  ACCOUNT_NUMBER: 'Account Number',
  ACCOUNT: 'Account',
  BROKERS_REP_ID: '**Broker**\'s **Rep** Id',
  EMAIL_ADDRESS: 'Email Address',
  CONFIRM_EMAIL_ADDRESS: 'Confirm Email Address',
  ENTER_OLD_PASSWORD: 'Please Enter Old Password',
  OLD_PASSWORD: 'Old Password',
  FORGOT_MY_PASSWORD: 'Forgot My Password',
  FORGOT_MY_USERNAME: 'Forgot My Username',
  FORGOT_CRED_NOTE: 'Forgot your {0}? We can send an email verification to the email address we have on file',
  LINK_ACCOUNTS: 'Link Accounts',
  ADD_NEW_LOGIN: 'Add New Login',
  OTHER_LOGINS: 'Other Logins',
  DATE_OF_BIRTH: 'Date Of Birth',
  REQUEST_ADDRESS_CHANGE: 'Request Address Change',
  STATE: 'State',
  EDIT_PROFILE: 'Edit Profile',
  CHANGE_PASSWORD: 'Change Password',
  CITY: 'City',
  LEGAL_ADDRESS: 'Legal Address',
  ADDRESS: 'Address',
  CURRENT_ADDRESS: 'Current Address',
  ACCOUNT_INFO: 'Account Information',
  MY_PROFILE: 'My Profile',
  EDIT_REASON_DIALOG: 'Edit Reason Dialog',
  QUESTION_MUST_BE_ANSWERED: 'The question must be answered',
  WRONG_ANSWER: 'Wrong answer',
  MAX_ALLOWED_LIMIT_REACHED: 'You have reached maximum allowed limit',
  SECURITY_QUESTIONS_SETUP_COMPLETED: 'Security Question Setup successfully completed',
  SECURITY_QUESTIONS_SETUP_FAILED: 'Security question couldn\'t be setup',
  LOGIN_TO_SETUP_SECURITY_QUESTIONS: 'Log in to setup security questions',
  SETUP_SECURITY_QUESTIONS: 'Setup security questions',
  ANSWER_SECURITY_QUESTIONS: 'Answer Security Question',
  PASSWORD_CHANGED_SUCCESSFULLY: 'Password changed successfully',
  PASSWORD_DOESNT_SATISFY: 'Password doesn\'t satisfy criteria',
  NEW_PASSWORD_AND_CONFIRM_DONT_MATCH: 'New Password and Confirm don\'t match',
  ENTER_CONFIRM_PASSWORD: 'Please Enter Confirm Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  CREATE_PASSWORD: 'Create Password',
  NEW_PASSWORD: 'New Password',
  DAY_HAVE_PASSED_SINCE_YOU_CHANGED_PASSWORD: 'At least 1 day must have passed since you changed your password.',
  PASSWORD_CAN_NOT_BE_ANY_OF_LAST: 'Your password can not be any of your last 5 passwords.',
  ENTER_NEW_PASSWORD: 'Please Enter New Password',
  PASSWORD_REQUIREMENTS: 'Password must be at least 8 characters long. Password must include at least one upper case, lower case, numeric and special character.',
  PASSWORD_REQUIREMENTS_SHORT: 'Password requirements',
  YOU_CAN_NOT_ENTER_CURRENT_PASSWORD: 'You can not enter your current password',
  AT_LEAST_CHARACTERS: 'Password must be at least {0} characters long',
  ALPHA_NUMERIC_SPECIAL: 'Password must include at least one upper case, lower case, numeric and one special character.',
  USERNAME_AND_PASSWORD_REQUIREMENTS: 'Username and Password Requirements: The Username must be unique.',
  SEND_MY_USERNAME: 'Send My Username',
  I_HAVE_READ_AND_AGREE: 'I HAVE READ AND AGREE WITH THE TERMS OF USE',
  CHECK_TO_RECEIVE_ELECTRONIC_DELIVERY: 'Check to receive electronic delivery of future investor communication.',
  RESET_YOUR_PASSWORD: 'Reset Your Password',
  IF_YOU_CONTINUE_TO_HAVE_PROBLEM: 'If you continue to have problems accessing your accounts, please contact your company administrator of {0} at {1}',
  CHECK_SPAM_IF_YOU_DONT_RECEIVE_EMAIL: 'If you do not receive the email, please check your spam and/or email filters for a message from {0}',
  YOU_SHOULD_RECEIVE_EMAIL: 'You should receive an email at {0} shortly.',
  YOU_SHOULD_RECEIVE_EMAIL_NO_ADDRESS: 'You should receive an email shortly.',
  USERNAME_SENT: 'Username Sent!',
  ASK_LATER: 'Ask Later',
  ANSWER: 'Answer',
  SECURITY_QUESTION: 'Security Question',
  ACCESS_ACCOUNT_BY_ANSWERING_QUESTIONS: 'If you forget your password, you can access your account by answering your security questions.',
  CHOOSE_QUESTIONS_AND_ANSWERS: 'Please choose questions and answers that can be used to verify your identity in case you forget your password. Because answers to these questions can be used to access your account, be sure to supply answers that are not easy for others to guess or discover.',
  REGISTRATION_QUESTIONS_AND_ANSWERS: 'Please select security questions and provide answers that can be used to authenticate your identity should you forget your password.',
  DIRECT_INQUIRIES_TO: 'Please direct all inquiries to',
  OR_VISIT: 'or visit',
  OR_VISIT_GPB: 'or visit the GPB Capital Website at',
  OR_EMAIL: 'or email',
  LAST_DIGITS_ONLY: 'Last {0} digits only',
  FILE_NOT_FOUND: 'File not found.',
  TAX_FORMS: 'Tax Forms',
  CONFIRMS: 'Confirms',
  CLIENT_STATEMENTS: 'Client Statements',
  CLIENT: 'Client',
  CITY_STATE_ZIP: 'City State Zip',
  FORMS: 'Forms',
  TAX_YEAR: 'Tax Year',
  FUND: 'Fund',
  YEAR: 'Year',
  TAX_STATEMENT: 'Tax Statement',
  SUBSCRIPTION: 'Subscription',
  TAX_GUIDE: 'Tax Guide',
  NEW_MESSAGES: 'New Messages',
  MORE: 'more',
  SELECT_ANY_STATEMENTS_FOR_DOWNLOAD: 'Select any statement to download',
  SELECT_ANY_REPORTS_FOR_DOWNLOAD: 'Select any reports to download',
  FILES_COULD_NOT_BE_FOUND: 'These files could not be found:',
  STATEMENTS: 'Statements',
  TIME_FRAME: 'Time frame',
  COMMUNICATION: 'Communications',
  TAX_DOCUMENTS: 'Tax Documents',
  DOCUMENTS: 'Documents',
  ANNOUNCEMENTS: 'Announcements',
  NO_NEW_ANNOUNCEMENTS: 'No New Announcements',
  ACCOUNT_NUM: 'Account #',
  ACCOUNT_NAME: 'Account Name',
  ACCOUNT_TYPE: 'Account Type',
  ACCOUNT_EMAIL: 'Account Email',
  REMOVE_ACCOUNT: 'Remove Account',
  ADD_ACCOUNT: 'Add an Account',
  HOUSE_ACCOUNT: 'House Account',
  REPORTS_NAME: 'Reports Name',
  REP_NAME: '**Rep** Name',
  BROKER_REP_ID: '**Broker** **Rep** Id',
  BROKER_NAME: '**Broker** Name',
  CUSTODIAN_NAME: '**Custodian** Name',
  QUALIFIED: 'Qualified',
  CLIENT_SEARCH: 'Client Search',
  TYPE_OF_CLIENT: 'Type of Client',
  CRD: 'CRD',
  DOWNLOAD_SELECTED_STATEMENTS: 'Download selected statements',
  BACK_TO_DUPMAIL_LIST: 'Back to DupMail List',
  BACK_TO_USER_LIST: 'Back to User List',
  BACK_TO_TERRITORY_LIST: 'Back to Territory List',
  BACK_TO_REP_LIST: 'Back to **Rep** List',
  BACK_TO_CUSTODIAN_LIST: 'Back to **Custodian** List',
  BACK_TO_BROKER_LIST: 'Back to **Broker**s List',
  BACK_TO_INVESTOR_LIST: 'Back to **Investor** List',
  INVESTOR: '**Investor**',
  INVESTOR_INFO: '**Investor** Information',
  INVESTOR_NAME: '**Investor** Name',
  INQUIRIES_OTHER_ISSUES: 'For inquiries other than account related issues please contact **Investor** Relations Department at',
  INQUIRIES_OTHER_ISSUES_GPB: 'For inquiries other than account related issues, please contact GPB **Investor** Relations Department at',
  BROKER: '**Broker**',
  CUSTODIAN: '**Custodian**',
  REP: '**Rep**',
  TERRITORY: 'Territory',
  USER: 'User',
  DUPMAIL: 'DupMail',
  DUPMAIL_NAME: 'DupMail Name',
  UNITS: '**Units**',
  CAPITAL: '**Capital**',
  COMMITMENT: 'Commitment',
  TITLE: 'Title',
  INACTIVE_INVESTMENTS: 'Inactive Investments',
  ACTIVE_INVESTMENTS: 'Active Investments',
  PORTFOLIO: 'Portfolio',
  VALUE: 'Value',
  COMMITMENTS: 'Commitments',
  ACTIVE: 'Hide Inactive',
  INVESTMENTS: 'Investments',
  DISTRIBUTION: 'Distributions',
  REDEMPTION: 'Redemption',
  PURCHASE: 'Purchase',
  TRANSFER: 'Transfer',
  POST_DIST_PYMTS: 'Post Dist Pymts',
  INCOME_ALLOCATION: 'Income/Loss',
  PAYEE_INFO: 'Payee Information',
  BROKER_INFO: '**Broker** Information',
  OWNERSHIP: 'Ownership',
  SHARES: 'Shares',
  AMOUNT: 'Amount',
  PAYMENT_TYPE: 'Payment Type',
  PAYMENT_DATE: 'Payment Date',
  TOTAL_REDEMPTION: 'Total Redemptions',
  YEAR_TO_DATE_REDEMPTION: 'Year To Date Redemptions',
  TOTAL_DISTRIBUTIONS: 'Total Distributions',
  YEAR_TO_DATE_DISTRIBUTIONS: 'Year To Date Distributions',
  SELECT_YEAR: 'Select Year',
  DEPOSIT_DATE: 'Deposit Date',
  EFFECTIVE_DATE: 'Effective Date',
  TRANSACTION_TYPE: 'Transaction Type',
  DETAILS: 'Details',
  TRANSACTION: 'Transactions',
  ADD_NEW_LOGIN_NOTE: 'To add a new login, we must first validate the email address.',
  SEARCH_ADDRESS: 'Search for Existing Email Address',
  INVALID_FORMAT: 'Invalid format',
  PLEASE_ENTER_EMAIL: 'Please enter email address',
  ACCOUNT_ALREADY_LINKED: 'The Email Address that you entered, already has access to this Account.',
  ACCOUNT_BY_EMAIL_FOUND: 'The Email Address that you entered is a known {0} account.',
  WISH_TO_LINK_ACCOUNT: 'Do you wish to link this account to the {0}?',
  ENTER_INFO_TO_CREATE_ACCOUNT: 'Please enter the following information about the new user that you creating.',
  NEW_USER_NAME: 'Name of New User',
  REQUIRED_FIELD: 'Field is required',
  PHONE_NUMBER: 'Phone Number',


  REGISTRATION_INVESTOR_STEP_2: 'To verify your account, please complete the information below.',
  CONTINUE_WITH_FURTHER_VERIFICATION: 'Continue for further verification',
  TRY_AGAIN: 'Try again',
  SHOW_PIN: 'Show PIN',
  HIDE_PIN: 'Hide PIN',
  INVESTOR_ID_NUMERIC: 'Investor ID must be numeric.',
  REP_ID_NUMERIC: '**Rep** ID must be numeric.',
  ENTER_INVESTOR_ID : 'Please enter Investor ID.',
  ENTER_REP_ID : 'Please enter **Rep** ID.',
  REP_ID: '**Rep** ID',
  INVESTOR_ID: 'Investor ID',
  DUPMAIL_ID: 'DupMail ID',
  SEND_EMAIL: 'Send Email',
  ADVISOR_STATEMENTS: 'Advisor Statements',
  REPORTS: 'Reports',
  PENDING: 'Pending',
  NEW_POSITION_FILE: 'New Position File',
  NEW_POSITION_FILE_CONFIRMATION_MESSAGE: 'Are you sure you want to submit a new position file?',
  REPORT_SENT: 'Report was submitted successfully',
  ACTIVATE: 'Activate',
  DEACTIVATE: 'Deactivate',
  DEACTIVATION_DATE: 'Deactivation Date',
  REACTIVATE: 'Reactivate',
  TWO_FA_TEXT: 'Protecting your account is our top priority. Please confirm your account by entering the authentication code below that we sent to "{0}".',
  TWO_FA_REMEMBER_LABEL: 'By checking this box, do not prompt me for a code within the next 30 days on this browser.',
  RESEND_CODE: 'Resend a new code',
  HAVE_NOT_RECEIVED: 'Haven\'t received it?',
  CODE_WAITING_TIME: 'It may take a minute to receive your code.',
  PROXY: 'Proxy',
  CONTROL_NUMBER_LABEL_TEXT: 'Enter your 11 digit control number located on the Proxy Form. Do not enter any spaces.',
  CONTROL_NUMBER_VALIDATION_ERROR: 'Invalid value',
  VOTE_AS_RECOMMENDS: 'CLICK HERE TO VOTE AS THE BOARD OF DIRECTORS RECOMMENDS',
  VOTE_NOTE: 'When you are finished making your selections, please click on the<br> <b>Register Your Vote</b> Button to finalize your selection.',
  VOTE_ALL_HINT: 'To vote on all issues using the same selection use one of the following:',
  VOTE_HINT: 'To vote on each issue separately - Make your selection below:',
  PROXY_DESCRIPTION: 'Your internet vote authorizes the Proxies to vote your shares in the same manner as if you marked, signed, and returned your Proxy Card. ',
  REGISTER_VOTE: 'CLICK HERE TO REGISTER YOUR VOTE',
  PROXY_VOTING: 'Proxy Voting',
  CLICK_HERE: 'Click here for',
};
